import React, { Component } from 'react';
import './OnboardingContainerAA.css';
import { withRouter} from 'react-router-dom';
import { connect } from 'react-redux';

class StepsNewQuiz extends Component {
    constructor(props) {
        super(props);

        this.state = {
            stage: this.props.step ? this.props.step:0 ,
            stepsSum: this.props.stepsSum ? this.props.stepsSum : 1,
            stageWidth:0,
            stepsTitel: this.props.stepsTitel ? this.props.stepsTitel : 'Skin quiz',
        };
    }

    componentDidMount(){
        let stageWidth = 0;
        try {
            stageWidth = (this.props.step / this.props.stepsSum) *100;
           
        } catch (error) {
            console.error(error)
        }
        this.setState({
            stageWidth : stageWidth
        })
    }

    componentWillReceiveProps(nextProps) {
        let stageWidth = 0;
        try {
            stageWidth = (nextProps.step / nextProps.stepsSum) *100;
        } catch (error) {
            console.error(error)
        }
        this.setState({
            stageWidth : stageWidth,
            stepsTitel: nextProps.stepsTitel,
        })
    }

   

    render() {
        return (
            <div className="quiz-steps-container" style={this.props.style}>
                <div className="">
                    <span>{this.state.stepsTitel} </span>
                    <i onClick={()=>{  this.props.history.push('/')  }} className="icon-close quiz-close-but"></i>
                </div>

                <div className="steps-divide-wrap">
                    <div className="steps-divide" style={{width: this.state.stageWidth +'%'}}></div>
                </div>
            </div>
        )
    }
}

export default withRouter(connect()(StepsNewQuiz))



// WEBPACK FOOTER //
// ./src/views/onboardingAA/StepsNewQuiz.js